<div class="w-full h-20 flex justify-center items-center gap-2 bg-black border-b border-gray-300 dark:border-gray-700">
    <img src="/assets/mb-logo.png" alt="Mercedes-Benz Logo" class="object-contain mb-star"/>
    <h1 class="text-3xl text-gray-700 dark:text-gray-100 ml-2">Sample Studio</h1>
</div>
